import clsx from 'clsx'
import React, { useState } from 'react'

import styles from './Circle.module.scss'
import { Flex } from '../flex/Flex'

interface CircleProps {
  className?: string
  text: string
  textOnHover: string
  onClick?: () => void
  preventHover?: boolean
  style?: React.CSSProperties
}

const Circle = ({ className, text, textOnHover, onClick, preventHover = false, style }: CircleProps) => {
  const [yellowCircle, setYellowCircle] = useState(false)
  const [circleText, setCircleText] = React.useState<string>(text)

  const onCircleMouseEnter = () => {
    if (preventHover) return
    setYellowCircle(true)
    setCircleText(textOnHover)
  }

  const onCircleMouseLeave = () => {
    if (preventHover) return
    setYellowCircle(false)
    setCircleText(text)
  }

  return (
    <Flex justify="center" className={clsx(styles.container, className)} onClick={onClick} style={style}>
      {yellowCircle ? (
        <Flex
          justify="center"
          className={styles.bigCircle}
          onMouseEnter={onCircleMouseEnter}
          onMouseLeave={onCircleMouseLeave}
        >
          <Flex className={styles.smallCircle}>
            <div className={styles.textContainer}>
              <p className={styles.textBlack}>{circleText}</p>
            </div>
          </Flex>
        </Flex>
      ) : (
        <Flex className={styles.circle} onMouseEnter={onCircleMouseEnter} onMouseLeave={onCircleMouseLeave}>
          <div className={styles.textContainer}>
            <p className={styles.textWhite}>{circleText}</p>
          </div>
        </Flex>
      )}
    </Flex>
  )
}

export default Circle
